import * as React from "react";
import type { SVGProps } from "react";
const SvgVoucher = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#voucher_svg__a)">
      <path d="M21 21H3a3 3 0 0 1-3-3v-4a1 1 0 0 1 1-1 1 1 0 0 0 0-2 1 1 0 0 1-1-1V6a3 3 0 0 1 3-3h18a3 3 0 0 1 3 3v4a1 1 0 0 1-1 1 1 1 0 0 0 0 2 1 1 0 0 1 1 1v4a3 3 0 0 1-3 3M2 14.83V18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-3.17a3 3 0 0 1 0-5.66V6a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v3.17a3 3 0 0 1 0 5.66" />
      <path d="M10 17a.93.93 0 0 1-.45-.11 1 1 0 0 1-.44-1.34l4-8a1 1 0 0 1 1.78.9l-4 8A1 1 0 0 1 10 17M16 17a3 3 0 1 1 0-5.999A3 3 0 0 1 16 17m0-4a1 1 0 1 0 0 2.002A1 1 0 0 0 16 13M8 13a3 3 0 1 1 0-6 3 3 0 0 1 0 6m0-4a1 1 0 1 0 0 2 1 1 0 0 0 0-2" />
    </g>
    <defs>
      <clipPath id="voucher_svg__a">
        <path fill="#fff" d="M0 3h24v18H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgVoucher;
